// One shared SSE connection for the whole app - Sidebar/Tickets/TicketDetail
// all subscribe to the same EventSource instead of each opening its own,
// which would otherwise multiply server-side connections for no reason.
//
// EventSource can't set custom headers, so the JWT travels as a query
// param (see tickets.routes.js authenticateStreamToken) rather than the
// usual Authorization header every other fetch() call in this app uses.
let eventSource = null;
let listeners = [];

const connect = () => {
  if (eventSource) return;
  const token = localStorage.getItem('accessToken');
  if (!token) return;

  const url = `${process.env.REACT_APP_BLADE_API_URL}/api/tickets/stream?token=${encodeURIComponent(token)}`;
  eventSource = new EventSource(url);

  eventSource.onmessage = (e) => {
    let data;
    try {
      data = JSON.parse(e.data);
    } catch (err) {
      return;
    }
    listeners.forEach((fn) => fn(data));
  };

  eventSource.onopen = () => {
    // A (re)connect - including the very first one - means any events
    // that fired while we weren't listening are gone for good (no
    // server-side replay buffer). Treat this as "go resync now", not
    // just "the pipe is open again".
    listeners.forEach((fn) => fn({ type: 'stream-open' }));
  };

  // No onerror handling needed beyond this - EventSource retries
  // connecting on its own, and onopen fires again once it succeeds.
};

// Returns an unsubscribe function. The underlying connection is closed
// once the last subscriber goes away (e.g. every ticket-related page has
// unmounted) and reopened on the next subscribe.
export const subscribeToTicketEvents = (handler) => {
  listeners.push(handler);
  connect();
  return () => {
    listeners = listeners.filter((fn) => fn !== handler);
    if (listeners.length === 0 && eventSource) {
      eventSource.close();
      eventSource = null;
    }
  };
};
